const translations = {
  "en": {
    "Create Profile": "Create Profile",
    "logout": "logout"
  },
  "zh-tw": {
    "Create Profile": "建立個人檔案",
    "logout": "登出"
  }
};

export default translations;
